import { loggedIn } from '../../../routes/conditional';
import {
  setDeliveryAddressOrderId,
  setDeliveryPrefOrderId,
  fetchDeliveryPreferences,
  checkoutOrderIdDetails,
  updateDeliveryPrefs,
  getCurrentDeliveryAddressForOrder,
} from '../../../redux/modules/orders';
import { chainAPIActions } from '../../../redux/middleware/chain';
import {
  getPendingOrdersDeliveryAddressOrderId,
  getPendingOrdersDeliveryPreferenceFlow,
} from '../../../redux/modules/root-reducer';

export const page = {
  path: '/orders/:orderId/change-delivery-preference',
  isAllowed: [loggedIn],
  action: ({ params }) => {

    return params.orderId.startsWith('S') ? chainAPIActions(
      fetchDeliveryPreferences(params.orderId),
      () => checkoutOrderIdDetails(params.orderId),
      () => setDeliveryAddressOrderId(params.orderId)
    ) : [checkoutOrderIdDetails(params.orderId), setDeliveryAddressOrderId(params.orderId)]
  }
};

export const selectedPref = {
  actionPath: '/actions/set-delivery-pref',
  action: ({ body: params, state }) => {
    const deliveryAddress = getCurrentDeliveryAddressForOrder(
      state.pendingOrders
    );
    const flow = getPendingOrdersDeliveryPreferenceFlow(state);
    return chainAPIActions(
      updateDeliveryPrefs(
        getPendingOrdersDeliveryAddressOrderId(state),
        deliveryAddress,
        'standard',
        flow
      ),
      () => setDeliveryPrefOrderId(params, flow)
    );
  },
};
